import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDashboard, sendFollowup } from '../api';

const S_CLASS = { sent:'s-sent', followup_1:'s-followup', followup_2:'s-followup',
  followup_3:'s-followup', replied:'s-replied', closed:'s-closed', new:'s-new', nurture:'s-nurture' };
const S_LABEL = { sent:'Sent', followup_1:'Follow-up 1', followup_2:'Follow-up 2',
  followup_3:'Follow-up 3', replied:'Replied', closed:'Closed', new:'New', nurture:'Nurture' };

export default function Dashboard({ showToast }) {
  const [data, setData]     = useState(null);
  const [sending, setSend]  = useState({});
  const nav = useNavigate();

  const load = () => getDashboard().then(r => setData(r.data)).catch(console.error);

  useEffect(() => {
    load();
  }, []);

  const handleSend = async (id, e) => {
    e.stopPropagation();
    setSend(p => ({...p,[id]:true}));
    try { await sendFollowup(id); showToast('Follow-up sent!'); load(); }
    catch(e) { showToast(safeErr(e, 'Send failed'), 'error'); }
    finally  { setSend(p => ({...p,[id]:false})); }
  };

  if (!data) return <div className="loading-center"><div className="spinner spinner-lg"/></div>;
  const { stats, recent_leads, due_followups } = data;

  return (
    <>
      <div className="metrics-grid">
        {[
          ['Total leads',        stats.total_leads,   'Active pipeline',                   ''],
          ['Emails sent',        stats.emails_sent,   'All time',                          ''],
          ['Sent today',         stats.today_sent,    new Date().toLocaleDateString('en-IN'), stats.today_sent>0?'up':''],
          ['Replies',            stats.total_replies, `${stats.reply_rate}% reply rate`,   'up'],
          ['Follow-ups due',     stats.followups_due, 'Due within 24h',                    stats.followups_due>0?'warn':''],
        ].map(([label,val,sub,cls]) => (
          <div key={label} className="metric-card">
            <div className="metric-label">{label}</div>
            <div className="metric-value">{val}</div>
            <div className={`metric-sub ${cls}`}>{sub}</div>
          </div>
        ))}
      </div>

      {due_followups.length > 0 && (
        <div className="card">
          <div className="card-header">
            <span className="card-title">⚡ Follow-ups due today</span>
            <span className="pill pill-amber">{due_followups.length} pending</span>
          </div>
          <div className="table-wrap">
            <table>
              <thead><tr><th>Lead</th><th>Company</th><th>Sequence</th><th>Action</th></tr></thead>
              <tbody>
                {due_followups.map(l => (
                  <tr key={l.id} onClick={() => nav(`/leads/${l.id}`)}>
                    <td style={{fontWeight:600}}>{l.name}</td>
                    <td>{l.company}</td>
                    <td><span className={`pill ${S_CLASS[l.status]}`}>{S_LABEL[l.status]}</span></td>
                    <td onClick={e=>e.stopPropagation()}>
                      <button className="btn btn-primary btn-sm" disabled={sending[l.id]}
                        onClick={e=>handleSend(l.id,e)}>
                        {sending[l.id] ? <span className="spinner spinner-sm"/> : '↑ Send now'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div className="card">
        <div className="card-header">
          <span className="card-title">Recent activity</span>
          <button className="btn btn-sm" onClick={() => nav('/leads')}>View all →</button>
        </div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Name</th><th>Company</th><th>Sector</th><th>Status</th><th>Updated</th></tr></thead>
            <tbody>
              {recent_leads.length === 0 && (
                <tr><td colSpan={5}>
                  <div className="empty-state" style={{padding:24}}>
                    <div className="empty-desc">No leads yet — <button className="btn btn-primary btn-sm" onClick={()=>nav('/generate')}>Generate leads</button></div>
                  </div>
                </td></tr>
              )}
              {recent_leads.map(l => (
                <tr key={l.id} onClick={() => nav(`/leads/${l.id}`)}>
                  <td style={{fontWeight:600,color:'var(--blue)'}}>{l.name}</td>
                  <td>{l.company}</td>
                  <td style={{color:'var(--text-2)'}}>{l.sector}</td>
                  <td><span className={`pill ${S_CLASS[l.status]||'s-new'}`}>{S_LABEL[l.status]||l.status}</span></td>
                  <td style={{color:'var(--text-2)'}}>{new Date(l.updated_at).toLocaleDateString('en-IN')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
